import { gql } from '@apollo/client';
import { TRANSLATED_STRING_FIELDS } from '@assets/i18n/config';

export const FETCH_ACCOUNT_GROUP_NAME = gql`
  query fetchAccountGroup($id: ObjectID!) {
    fetchAccountGroup(accountGroupId: $id) {
      accountGroup { translatedName { ${TRANSLATED_STRING_FIELDS} } }
    }
  }
`;
